import '../scss/style.scss';

import Rellax from 'rellax';
import ScrollReveal from 'scrollreveal';
import './modules/swipers.js';
import {fleetSwiperChangeHandler, realisationSwiperChangeHandler} from './modules/swipers';
import {ModalForm} from './modules/modal';
import toggleHandler from './modules/toggleHandler';
import Accordion from './modules/accordion';


window.fleetSwiperChangeHandler = fleetSwiperChangeHandler;
window.realisationSwiperChangeHandler = realisationSwiperChangeHandler;
window.toggleHandler = toggleHandler;

import CookieConsent from './modules/cookie-consent.js';
// import Tabs from './modules/tabs';
import ScrollAction from './modules/scroll-action.js';
import MobileNavigation from './modules/mobile-navigation.js';

const cookie = new CookieConsent({
  cookieWrapper: '.js-cookie-consent',
  cookieCancel: '.js-cookie-cancel',
  expirationDays: 30
});
cookie.init();

if ( window.location.pathname == '/' ){
  const scrollAction = new ScrollAction({
    wrapper: '.js-burger-nav',
    offset: '.stripe',
    classToAdd: "is-visible",
  });
  scrollAction.init();
}

const accordion_faq = new Accordion({
  main_item:'.js-accordion__header',
  collapse: true
});
accordion_faq.init();



let formModal = new ModalForm({
  modal:'.js-wpcf7-response-modal',       //* container holding modal
  formResponse:'.wpcf7-response-output',      //* wpcf7 response div
  modalCancel: '.js-modal__cancel',       //* elements on which Modal will hide
});
formModal.init();


var slideUp = {
  distance: '25%',
  origin: 'bottom',
  opacity: 0,
  easing: 'ease-in-out',
  duration: 800,
  viewFactor:0.15
};

var slideFromLeft = {
  distance: '25%',
  origin: 'left',
  opacity: 0,
  easing: 'ease-in-out',
  duration: 800,
  viewFactor:0.15
};
var slideFromRight = {
  distance: '25%',
  origin: 'right',
  opacity: 0,
  easing: 'ease-in-out',
  duration: 800,
  viewFactor:0.15
};

ScrollReveal().reveal('.reveal', slideUp);
ScrollReveal().reveal('.revealLeft', slideFromLeft);
ScrollReveal().reveal('.revealRight', slideFromRight);



const mobileNav = new MobileNavigation({
  activator: '.js-burger-nav',
  cancel: '.js-mobile-nav-cancel',
  header: '.site-header',
});
mobileNav.init();


const rellax = new Rellax('.parallax');


if (window.innerWidth > 1440) {
  const rellax1 = new Rellax('.js-parallax-fleet', {
    speed: -2,
    // wrapper: '.js-test',
    // relativeToWrapper: true,
    center: true,
    round: true,
    vertical: true,
  })
}


// function scrollAnchors(e, respond = null) {
// 	const distanceToTop = el => Math.floor(el.getBoundingClientRect().top);
// 	e.preventDefault();
// 	var targetID = (respond) ? respond.getAttribute('href') : this.getAttribute('href');
// 	const targetAnchor = document.querySelector(targetID);
//   if (!targetAnchor) return;
//   mobileNav.hide();
// 	const originalTop = distanceToTop(targetAnchor);
// 	window.scrollBy({ top: originalTop, left: 0, behavior: 'smooth' });
// 	const checkIfDone = setInterval(function() {
// 		const atBottom = window.innerHeight + window.pageYOffset >= document.body.offsetHeight - 2;
// 		if (distanceToTop(targetAnchor) === 0 || atBottom) {
// 			targetAnchor.tabIndex = '-1';
// 			targetAnchor.focus();
//       window.history.pushState('', '', targetID);
// 			clearInterval(checkIfDone);
// 		}
// 	}, 100);
// }

// function scrollTo() {
// 	var links = document.getElementsByTagName('a');
// 	for (var i = 0; i < links.length; i++) {
// 		var link = links[i];
// 		if ((link.href && link.href.indexOf('#') != -1) && ((link.pathname == location.pathname) || ('/' + link.pathname == location.pathname)) && (link.search == location.search)) {
//       link.onclick = scrollAnchors;
// 		}
// 	}
// }
// scrollTo();

document.querySelectorAll('a[href^="/#"]').forEach(anchor => {
  anchor.addEventListener('click', function (e) {
    console.log('ok');
      e.preventDefault();
      const attr = this.getAttribute('href').replace('/', '');

      if(document.querySelector(attr)){
        mobileNav.hide();
        document.querySelector(attr).scrollIntoView({
            behavior: 'smooth'
        });
      }else{
        window.location.href = '/'+attr;
      }
  });
});

try{
  $('html,body').animate({
    scrollTop: $(window.location.hash).offset().top
  });
}catch(err){

}